import styled from 'styled-components';

import IntroSection from '../components/IntroSection';

export default styled(IntroSection)`
  position: relative;
  width: 100%;
  min-height: 100vh;
`;
